import { ConfigRepository } from '../internal/repositories/ConfigRepository';

export class ServiceBusController {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    constructor(private configRepository: ConfigRepository) {}

    public loadConfigs = async (payload: string[]) => this.configRepository.getConfigs(payload);
}
